(function() {
'use strict';

const TR = angular.module('TR');

TR.directive('destinationTitle', function(
    resourceService,
    pageStrand,
    loggingService,
    destinationService) {
    return {
        restrict: 'E',
        replace: true,
        template: '<span>{{ title }}</span>',
        scope: {
            title: '@?',
            dest: '=',
            allowEstab: '=' // Required on estab page because search pages display parent dest
        },
        link(scope) {
            const strandResources = {
                1: resourceService.getDeferred('HOTELSIN'),
                2: resourceService.getDeferred('HOLIDAYSIN')
            };
            const reVarStr = /{/;
            let strand;
            let countryId;
            let bc;

            // Destination object receives async updates
            scope.$watch('dest', init, true);

            function _destTitleFallback(dest) {
                scope.title = `${(strandResources[strand] || strandResources[1])()} ${dest.Title}`;
                return true;
            }

            function init(dest) {
                if (!dest || !dest.BreadcrumbTrail) {
                    return;
                }
                strand = pageStrand.fromRoute(dest);

                // Values may be removed by `getParentDestination()`
                bc = dest.BreadcrumbTrail;
                countryId = dest.CountryId;

                if (!scope.allowEstab) {
                    // Display estab parent destination by default
                    // i.e. 'choose a different hotel' results
                    dest = getParentDestination(dest);
                }
                dest.PageStrand = strand;

                destinationService.getText(dest, {
                    customErrCallback: {
                        404() {
                            _destTitleFallback(dest);
                        },
                        400() {
                            _destTitleFallback(dest);
                        }
                    }
                }).then(function(result) {
                    // `PageHeading` template should exist ideally
                    const inResource = resourceService.get('HOLIDAYSINTITLE');
                    const titleStr = String.supplant(
                            // Non-estab: fall back to PageTitle, Estab: fall back to hotel name
                            inResource || result.PageHeading || (!scope.allowEstab && result.PageTitle) || '{name}',
                            getVarMap(dest)
                        );
                    if (reVarStr.test(titleStr)) {
                        // Error if any vars are not transformed
                        const logMsg = `Untransformed template: ${titleStr
                                        } | ${window.location.href
                                        } | getText: ${angular.toJson(result)}`;
                        loggingService.logError(logMsg);
                    } else {
                        scope.title = titleStr;
                    }
                });
            }

            function getParentDestination(dest) {
                //if the destination is an estab, walk back one level up the breadcrumb and the return the parent destination
                const pDest = (dest.EstablishmentId && bc && bc.length > 1) ? bc[bc.length - 2] : dest;
                // Add properties required by `getVarMap()` (returns a new object)
                return angular.extend({
                        ShortTitle: pDest.Title,
                        SummaryTitle: pDest.Title
                    }, pDest);
            }

            function getVarMap(dest) {
            // Variable mapping in string templates i.e. {name}
            // Also supports legacy numeric vars i.e. {0}
                const inResource = resourceService.get(
                    dest.IsPOI ? 'NearDestination' : 'InDestination'
                );

                return {
                    0: dest.Title,
                    1: inResource,
                    name: dest.ShortTitle,
                    in: inResource,
                    location: dest.SummaryTitle,
                    country: destinationService.getBreadcrumbTitle(dest, bc => bc.ObjectId === countryId)
                };
            }
        }
    };
});
})();
